import { defineAsyncComponent } from "vue";
import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";
// Rotas Infraestrutura
const infraRoutes = [
    { path: "/informativo", name: "informativo", component: defineAsyncComponent(() => import("@/views/infra/Informativo.vue")) },
    { path: "/usuario", name: "usuario", component: defineAsyncComponent(() => import("@/views/infra/Usuario.vue")) },
    { path: "/empresa", name: "empresa", component: defineAsyncComponent(() => import("@/views/infra/Empresa.vue")) },
    { path: "/unidade", name: "unidade", component: defineAsyncComponent(() => import("@/views/infra/Unidade.vue")) },
    { path: "/pais", name: "pais", component: defineAsyncComponent(() => import("@/views/infra/Pais.vue")) },
    { path: "/estado", name: "estado", component: defineAsyncComponent(() => import("@/views/infra/Estado.vue")) },
    { path: "/regiao", name: "regiao", component: defineAsyncComponent(() => import("@/views/infra/Regiao.vue")) },
    { path: "/fusoHorario", name: "fusoHorario", component: defineAsyncComponent(() => import("@/views/infra/Fuso_Horario.vue")) }
];
// Rotas Fornecedor
const fornecRoutes = [
    { path: "/fornecedorCliente", name: "fornecedorCliente", component: defineAsyncComponent(() => import("@/views/fornec/Fornecedor_Cliente.vue")) },
    { path: "/colaborador", name: "colaborador", component: defineAsyncComponent(() => import("@/views/fornec/Colaborador.vue")) },
    { path: "/colaborador_Projeto/:colaborador_Id", props: true, name: "colaborador_Projeto", component: defineAsyncComponent(() => import("@/views/fornec/Colaborador_Projeto.vue")), },
    { path: "/categoria", name: "Categoria", component: defineAsyncComponent(() => import("@/views/fornec/Categoria.vue")), },
    { path: "/categoriaCusto", name: "categoriaCusto", component: defineAsyncComponent(() => import("@/views/fornec/Categoria_Custo.vue")) },
    { path: "/contratos", name: "contratos", component: defineAsyncComponent(() => import("@/views/fornec/Contratos.vue")) },
    { path: "/adendos", name: "adendos", component: defineAsyncComponent(() => import("@/views/fornec/Adendos.vue")) },
    { path: "/adendoColaborador", name: "adendoColaborador", component: defineAsyncComponent(() => import("@/views/fornec/Adendo_Colaborador.vue")) },
    { path: "/categoriareembolso", name: "CategoriaReembolso", component: defineAsyncComponent(() => import("@/views/fornec/Categoria_Reembolso.vue")) },
    { path: "/tiporeembolso", name: "TipoReembolso", component: defineAsyncComponent(() => import("@/views/fornec/Tipo_Reembolso.vue")) },
    { path: "/abaReembolso", name: "abaReembolso", component: defineAsyncComponent(() => import("@/views/fornec/abaReembolso/Aba_Reembolso.vue")) },
    { path: "/restritivos_Reembolso", name: "restritivos_Reembolso", component: defineAsyncComponent(() => import("@/views/fornec/Restritivos_Reembolso.vue")) },
    { path: "/projetos", name: "Projetos", component: defineAsyncComponent(() => import("@/views/fornec/Projetos.vue")) },
    { path: "/projeto_Colaborador/:projeto_Id", props: true, name: "projeto_Colaborador", component: defineAsyncComponent(() => import("@/views/fornec/Projeto_Colaborador.vue")), },
    { path: "/timesheet", props: true, name: "timesheet", component: defineAsyncComponent(() => import("@/views/fornec/Timesheet.vue")) },
    { path: "/reembolso", props: true, name: "reembolso", component: defineAsyncComponent(() => import("@/views/fornec/Reembolso.vue")) },
    { path: "/AceiteReembolso", props: true, name: "Aceite_Reembolso", component: defineAsyncComponent(() => import("@/views/fornec/AceiteReembolso.vue")) },
    { path: "/Diaria", props: true, name: "Diaria", component: defineAsyncComponent(() => import("@/views/fornec/Diaria.vue")) },
    { path: "/Editar_Reembolso", props: true, name: "Editar_Reembolso", component: defineAsyncComponent(() => import("@/views/fornec/Editar_Reembolso.vue")) },
    { path: "/Horas_Adicionais", props: true, name: "Horas_Adicionais", component: defineAsyncComponent(() => import("@/views/fornec/Horas_Adicionais.vue")) },
    { path: "/material_Colaborador/:colaborador_Id", props: true, name: "material_Colaborador", component: defineAsyncComponent(() => import("@/views/fornec/Material_Colaborador.vue")), },
    { path: "/limites_Reembolso", props: true, name: "limites_Reembolso", component: defineAsyncComponent(() => import("@/views/fornec/Limites_Reembolso.vue")), },
    { path: "/timesheetclock", name: "timesheetClock", component: defineAsyncComponent(() => import("@/views/fornec/timesheet/timesheetClock.vue")), },
];
// Rotas Cadastro
const cadRoutes = [
    { path: "/formas_de_Pagamento", name: "formas_de_Pagamento", component: defineAsyncComponent(() => import("@/views/cad/Formas_de_Pagamento.vue")) },
    { path: "/cnae", name: "cnae", component: defineAsyncComponent(() => import("@/views/cad/CNAE.vue")) },
    { path: "/calendario", name: "calendario", component: defineAsyncComponent(() => import("@/views/cad/Calendario.vue")) },
    { path: "/material/:despesas_Id?", props: true, name: "material", component: defineAsyncComponent(() => import("@/views/cad/Material.vue")) },
    { path: "/time_Colaborador", name: "time_Colaborador", component: defineAsyncComponent(() => import("@/views/cad/Time_Colaborador.vue")) },
    { path: "/tipo_Material", name: "Tipo_Material", component: defineAsyncComponent(() => import("@/views/cad/Tipo_Material.vue")) },
    { path: "/statusMaterial", name: "StatusMaterial", component: defineAsyncComponent(() => import("@/views/cad/Status_Material.vue")) },
    { path: "/situacao", name: "Situacao", component: defineAsyncComponent(() => import("@/views/cad/Situacao.vue")) },
    { path: "/moeda", name: "Moeda", component: defineAsyncComponent(() => import("@/views/cad/Moeda.vue")) }
];
// Rotas Contas
const contRoutes = [
    { path: "/contas", name: "Contas", component: defineAsyncComponent(() => import("@/views/cont/contas/Contas.vue")) },
    { path: "/pertences", name: "Pertences", component: defineAsyncComponent(() => import("@/views/cont/Pertences.vue")) },
    { path: "/material_itens", name: "material_itens", component: defineAsyncComponent(() => import("@/views/cont/Material_Itens.vue")) },
    { path: "/material_Detalhes", name: "material_Detalhes", component: defineAsyncComponent(() => import("@/views/cont/Material_Detalhes.vue")) },
    { path: "/despesas", props: true, name: "despesas", component: defineAsyncComponent(() => import("@/views/cont/Despesas.vue")) }
];
// Rotas Matriz
const mtzRoutes = [
    { path: "/Area", name: "Area", component: defineAsyncComponent(() => import("@/views/mtz/Area.vue")) },
    { path: "/Atividade", name: "Atividade", component: defineAsyncComponent(() => import("@/views/mtz/Atividade.vue")) },
    { path: "/Cargo", name: "Cargo", component: defineAsyncComponent(() => import("@/views/mtz/Cargo.vue")) },
    { path: "/Conhecimento", name: "Conhecimento", component: defineAsyncComponent(() => import("@/views/mtz/Conhecimento.vue")) },
    { path: "/Funcao", name: "Funcao", component: defineAsyncComponent(() => import("@/views/mtz/Funcao.vue")) },
    { path: "/Responsabilidade", name: "Responsabilidade", component: defineAsyncComponent(() => import("@/views/mtz/Responsabilidade.vue")) },
    { path: "/Equipe", name: "Equipe", component: defineAsyncComponent(() => import("@/views/mtz/Equipe.vue")) },
    { path: "/Tema", name: "Tema", component: defineAsyncComponent(() => import("@/views/mtz/Tema.vue")) },
    { path: "/Parametrizacao_Indicadores", name: "Parametrizacao_Indicadores", component: defineAsyncComponent(() => import("@/views/mtz/Parametrizacao_Indicadores.vue")) },
    { path: "/Checklist", name: "Checklist", component: defineAsyncComponent(() => import("@/views/mtz/Checklist.vue")) },
    { path: "/Matriz_Competencia/:funcaoId?", props: true, name: "Matriz_Competencia", component: defineAsyncComponent(() => import("@/views/mtz/Matriz_Competencia.vue")) },
    { path: "/Treinamentos", name: "Treinamentos", component: defineAsyncComponent(() => import("@/views/mtz/Treinamentos.vue")) },
    { path: "/ChecklistColaborador", name: "ChecklistColaborador", component: defineAsyncComponent(() => import("@/views/mtz/ChecklistColaborador.vue")) },
    { path: "/Avaliacao", name: "Avaliacao", component: defineAsyncComponent(() => import("@/views/mtz/ChecklistColaborador.vue")) },
    // Sprint 4 / P23 — dashboard executivo do MTZ.
    { path: "/Dashboard_MTZ", name: "Dashboard_MTZ", component: defineAsyncComponent(() => import("@/views/mtz/Dashboard_MTZ.vue")) },
];
// Rotas Chamado
const chmRoutes = [
    { path: "/GrupoDistribuicao", name: "GrupoDistribuicao", component: defineAsyncComponent(() => import("@/views/chm/GrupoDistribuicao.vue")) },
    { path: "/TemplateChamado", name: "TemplateChamado", component: defineAsyncComponent(() => import("@/views/chm/TemplateChamado.vue")) },
    { path: "/Chamados/:codigoChamado?", props: true, name: "Chamados", component: defineAsyncComponent(() => import("@/views/chm/MeusChamados.vue")) },
];
// Rotas Roteiro
const rotRoutes = [
    { path: "/Roteiro", name: "Roteiro", component: defineAsyncComponent(() => import("@/views/rot/Roteiro.vue")) },
    { path: "/Roteiro_Grupo", name: "Roteiro_Grupo", component: defineAsyncComponent(() => import("@/views/rot/Roteiro_Grupo.vue")) },
    { path: "/Acoes_Corretivas", name: "Acoes_Corretivas", component: defineAsyncComponent(() => import("@/views/rot/Acoes_Corretivas.vue")) },
];
// Rotas Principais
const routes = [
    {
        path: "/",
        redirect: "/home",
        component: defineAsyncComponent(() => import("@/layout/Layout.vue")),
        children: [
            { path: "/DashboardMakeForTests", name: "dashboard", component: defineAsyncComponent(() => import("@/views/Dashboard.vue")) },
            { path: "/home", name: "home", component: defineAsyncComponent(() => import("@/views/Home.vue")) },
            ...infraRoutes,
            ...fornecRoutes,
            ...cadRoutes,
            ...contRoutes,
            ...mtzRoutes,
            ...chmRoutes,
            ...rotRoutes
        ]
    },
    {
        path: "/",
        component: defineAsyncComponent(() => import("@/components/page-layouts/Auth.vue")),
        children: [
            { path: "/sign-in/:route?", name: "sign-in", props: true, component: defineAsyncComponent(() => import("@/views/crafted/authentication/basic-flow/SignIn.vue")) },
            { path: "/sign-up", name: "sign-up", component: defineAsyncComponent(() => import("@/views/crafted/authentication/basic-flow/SignUp.vue")) },
            { path: "/password-reset", name: "password-reset", component: defineAsyncComponent(() => import("@/views/crafted/authentication/basic-flow/PasswordReset.vue")) },
            { path: "/definirSenha/:firstAccess?", props: true, name: "definirSenha", component: defineAsyncComponent(() => import("@/views/crafted/authentication/basic-flow/DefinirSenha.vue")) }
        ]
    },
    { path: "/RespostaChecklist/:Guid_Resposta", props: true, name: "RespostaChecklist", component: defineAsyncComponent(() => import("@/views/mtz/RespostaChecklist.vue")) },
    {
        path: "/404",
        name: "404",
        component: defineAsyncComponent(() => import("@/views/crafted/authentication/Error404.vue"))
    },
    {
        path: "/500",
        name: "500",
        component: defineAsyncComponent(() => import("@/views/crafted/authentication/Error500.vue"))
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404"
    }
];
const router = createRouter({
    history: createWebHashHistory(),
    routes
});
router.beforeEach(() => {
    store.commit(Mutations.RESET_LAYOUT_CONFIG);
    store.dispatch(Actions.VERIFY_AUTH);
    store.dispatch(Actions.CLEAR_BREADCRUMB);
    setTimeout(() => {
        window.scrollTo(0, 0);
    }, 100);
});
const checkRecursive = (menu, key) => {
    const lowerKey = key.toLowerCase(); // Converte a chave para min�sculas apenas uma vez
    return menu.some(item => {
        return item.heading
            ? removeNewLines(item.route).toLowerCase() === lowerKey
            : checkRecursive(item.sub, lowerKey);
    });
};
const extractSubString = (url) => {
    const parts = url.split('/');
    return parts.length > 1 ? removeNewLines(parts[1]) : "";
};
const removeNewLines = (input) => {
    return input.replace(/\r\n/g, '');
};
router.beforeResolve((to, from, next) => {
    if (window.location.href.includes('http://localhost'))
        return next();
    const safepages = ['home', 'sign-in', 'sign-up', 'password-reset', 'definirSenha', 'RespostaChecklist'].map(page => page.toLowerCase()); // Converte para min�sculas
    const menus = store.getters.getMenus;
    const toPage = extractSubString(to.path).toLowerCase(); // Converte para minusculas
    if (!store.getters.isUserAuthenticated && !safepages.includes(toPage) && !checkRecursive(menus, toPage)) {
        let signInPath = { path: "/sign-in" };
        if (to.path !== "/" && !["sign-in", "sign-up", "password-reset", "definirSenha", "home"].includes(to.name)) {
            signInPath.path += `/${btoa(to.fullPath)}`;
            router.push(signInPath);
        }
    }
    else if (safepages.includes(toPage) || checkRecursive(menus, toPage)) {
        return next();
    }
    else if (to.path.toLowerCase() !== '/home') {
        console.log('Redirecionando para /home da rota => ', to.path);
        return next('/home');
    }
    else {
        return next();
    }
});
export default router;
//# sourceMappingURL=index.js.map